module.exports = function() {
  return new Worker(__webpack_public_path__ + "0e6c894c65a974856cbc.worker.js");
};